export default {
  computed: {
    payloadMap() {
      const items = this.content && this.content.preview_payload_map
      return Array.isArray(items) ? items : []
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/mixins/PreviewPayloadMapMixin.js